// src/version.js
export const appVersion = process.env.REACT_APP_VERSION || require('../package.json').version;
